/** "Socket.IO" namespaces */
export enum SocketIOEventTypeEnum {
  THREAD = '/thread',
  TASK = '/task',
  NOTIFICATION = '/notification',
  EXTERNAL_NOTIFICATION = '/external-notification',
  NET_PING_DEVICE = '/net-ping-device',
  PROJECT = '/project',
  TEST = '/test',
  HELPDESK = '/helpdesk',
  DEAL = '/deal',
  DEALS_GROUP = '/deals-group',
  BUDGET_REQUEST = '/budget-request',
  PURCHASE = '/purchase',
  EQUIPMENT_REPORT = '/control',
  CCTV_EVENT_REPORT = '/cctv-event-report',
  RTSP_PLAYER = '/rtsp-player',
  TELEMETRY = '/telemetry',
}
